import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: ['en', 'pl'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          login: {
            description: 'Login',
            longDescription: 'Enter your login details',
          },
          account: {
            description: 'My Account',
            newUser: 'Add new user',
            firstName: 'First Name',
            lastName: 'Last Name',
            warehouse: 'Warehouse',
            password: 'Password',
            repeatPassword: 'Repeat Password',
            userPermissions: 'User Permissions',
            newUserForm: 'New User Form',
            users: 'Users',
            logout: 'Logout',
            userList: 'Users List',
            userName: 'User',
            userRole: 'Role',
            accountStatus: 'Account Status',
            action: 'Action',
            userLine: 'Line',
          },
          bins: {
            bin: 'Location',
            binList: 'Bins List',
            name: 'Bin name',
            warehouse: 'Warehouse',
            create: 'Creation form',
            editForm: 'Edit bin form',
          },
          button: {
            confirmButton: 'Confirm',
            addNewUser: 'Add new user',
            edit: 'Edit',
            addBeer: 'Add new material',
            add: 'Add',
            generateReport: 'Generate report',
            addAttachment: 'Add attachment',
            startAction: 'Start action',
            close: 'Close',
          },
          masterData: {
            descriptionBeer: 'Beer',
            brand: 'Brand',
            packages: 'Packages',
            beerList: 'Beer List',
            desIncompatibilities: 'Incompatibilities',
            origins: 'Origins',
            area: 'Area',
            type: 'Type',
            description: 'Description',
            additionalDes: 'Additional Description',
            reasons: 'Reasons for incompatibilities',
            warehouse: 'Warehouse',
            line: 'Production Line',
            button: {
              saveChanges: 'Save changes',
              save: 'Save',
              cancel: 'Cancel',
            },
            specification: {
              title: 'Specification',
              specificationList: 'Specification List',
              parameter: 'Parameter',
              unit: 'Unit',
              minValueX: 'Min value zone X',
              maxValueX: 'Max value zone X',
              minValueB: 'Min value zone B',
              maxValueB: 'Max value zone B',
              minDefaultValue: 'Minimum specification value',
              maxDefaultValue: 'Maximum specification value',
              nominalDefaultValue: 'Nominal specification value',
              defaultValue: 'Specification',
              addButton: 'Add Specification',
              description: 'Parameter',
              whLine: 'Warehouse/Line',
              minX: 'Zone X',
              minB: 'Zone B',
              maxB: 'Zone B',
              maxX: 'Zone X',
              isLineSpecific: 'Line specific specification',
              decisionMaker: 'Decision Maker',
              addNewSpecification: 'Add new specification',
            },
            mailing: 'Mailing',
            recipients: 'Recipients',
            recipientsList: 'Recipients List',
            email: 'Email',
            isActive: 'Is Active',
            mailingList: 'Mailing List',
            mailingGroup: 'Mailing Group',
            mailingDetail: 'Mailing Group Detail',
          },
          pz05: {
            description: 'PZ05 Register',
            listIncompatibilities: 'List of incompatibilities',
            addIncompatibility: 'Add incompatibility',
            reportPZ05: 'PZ05 Report',
            incompatibilities: {
              origins: {
                addForm: 'Product origin creation form',
                description: 'Product origin',
                editForm: 'Product origin edit form',
              },
              area: {
                addForm: 'Incompatibility area creation form',
                description: 'Incompatibility area',
                editForm: 'Incompatibility area edit form',
              },
              type: {
                addForm: 'Incompatibility type creation form',
                description: 'Incompatibility type',
                editForm: 'Incompatibility type edit form',
              },
              description: {
                addForm: 'Incompatibility description creation form',
                description: 'Incompatibility description',
                editForm: 'Incompatibility description edit form',
              },
              addDes: {
                addForm: 'Incompatibility additional description creation form',
                description: 'Incompatibility additional description',
                editForm: 'Incompatibility additional description edit form',
              },
              reasons: {
                reasonsList: 'Reasons for incompatibilities list',
                addForm: 'Incompatibility reason creation form',
                description: 'Incompatibility reason',
                editForm: 'Incompatibility reason edit form',
                button: 'Add new reason',
                area: 'Area',
                type: 'Type',
                des: 'Description',
                addDes: 'Additional description',
                decisionMaker: 'Decision Maker',
              },
            },
            report: {
              dateFrom: 'Start date',
              dateTo: 'End date',
              warehouse: 'Warehouse',
            },
            addForm: 'Add new incompatibility form',
            editForm: 'Edit incompatibility form',
            productDetails: 'Product details',
            comments: 'Comments',
            attachments: 'Attachments',
            register: 'PZ05 Register',
            tooltipFilter:
              'Available fields for filtering: report number, index, material name and required action',
            statusNew: 'New',
            statusInProgress: 'In progress',
            statusCompleted: 'Done',
            filter: 'Filter',
            list: {
              reportNumber: 'Report number',
              warehouse: 'Source warehouse',
              user: 'User',
              dateCreated: 'Creation date',
              index: 'Index',
              materialName: 'Material name',
              type: 'Incompatibility type',
              actionRequired: 'Action required',
              status: 'Status',
            },
            incompatibilityReport: 'Incompatibility report',
            redCard: 'Red card',
            basicInfo: 'Basic information',
            dateCreated: 'Report creation date',
            reportDetails: 'Report details',
            productOrigin: 'Product origin',
            productInfo: 'Product details',
            actions: 'Actions',
            decision: 'Decision',
            decisionComments: 'Comments',
            qualification: 'Qualification',
            actionDetail: {
              name: 'Name',
              qty: 'Quantity',
              qtyHL: 'HL',
              expect: 'Expected action',
              role: 'Role',
              date: 'Date',
              split: 'Split',
              changeQty: 'Change quantity',
              action: 'Action',
              newQty: 'New quantity',
              description: 'Enter the value to divide',
              val1: 'Value 1',
              val2: 'Value 2',
            },
          },
          brand: {
            description: 'Brand',
            create: 'Creation form',
            descriptionField: 'Description',
            edit: 'Brand edit form',
          },
          package: {
            description: 'Package',
            create: 'Creation form',
            descriptionField: 'Description',
            edit: 'Package edit form',
          },
          beer: {
            beerList: 'Beer List',
            index: 'Index',
            name: 'Name',
            durability: 'Durability',
            quantity: 'Quantity/PAL',
            hl: 'HL/cas',
            package: 'Package',
            brand: 'Brand',
            editForm: 'Beer edit form',
            addForm: 'New beer form',
            batch: 'Batch',
            expirationDate: 'Expiration date',
            qty: 'Quantity [cas]',
            qtyPAL: 'Quantity [PAL]',
            qtyHL: 'Quantity [HL]',
            notFull: 'Production end qty',
            fullPallets: 'Full pallets',
          },

          pz04: {
            description: 'PZ04 Register',
            listIncompatibilities: 'List of incompatibilities',
            addIncompatibility: 'Add incompatibility',
            reportPZ04: 'PZ04 Report',
            register: 'PZ04 Register',
            addForm: 'Add new incompatibility form',
            type: 'Incompatibility type',
            reason: 'Incompatibility reason',
            data: 'Incompatibility data',
            dataProduct: 'Product data',
            details: 'Additional information',
            beerLocked: 'Beer locked',
            beerUnlocked: 'Beer unlocked',
            typeLock: 'Lock type',
            hourBlockFrom: 'Expiration date from hour',
            hourBlockTo: 'Expiration date to hour',
            binList: 'Bins List',
            yes: 'Yes',
            no: 'No',
            yellowCard: 'Yellow card',
            redCard: 'Red card',
            title: 'Incompatibility',
            commentsPlaceholder: 'Enter comment',
            PODEJRZENIE_NIEZGODNOSCI: 'Suspicion of incompatibility',
            RAPORT_NIEZGODNOSCI: 'Incompatibility report',
            KWARANTANNA: 'Quarantine',
            ssccPlaceholder: 'Enter SSCC, separating them with commas or enter',
            microDateFrom: 'Production date from hour',
            microDateTo: 'Production date to hour',
            dataMicroCulture:
              'Microculture data (to be completed by the microbiology laboratory)',
            editForm: 'Edit incompatibility form',
            qtyToBlock: 'Quantity to block',
            releaseDate: 'Potential release date',
            list: {
              reportNumber: 'Incompatibility number',
              type: 'Type',
              reason: 'Reason',
              orderNumber: 'Order',
              index: 'Index',
              materialName: 'Material name',
              batch: 'Batch',
              BBT: 'BBT',
              dateCreated: 'Creation date',
              dateMicroCulture: 'Microculture',
              status: 'Status',
            },
            reasons: {
              MIKROBIOLOGIA: 'Microbiology',
              FIZ_CHEM: 'Physicochemical',
            },
            typesLock: {
              CALE_ZLECENIE: 'Whole order',
              BLOKADA_GODZIN: 'Hourly lock',
              BLOKADA_BINOW: 'Bin lock',
              BLOKADA_SSCC: 'SSCC lock',
            },
            statuses: {
              NEW: 'New',
              IN_PROGRESS: 'In progress',
              DONE: 'Done',
              DO_ZABLOKOWANIA: 'To be locked',
              ZABLOKOWANE: 'Locked',
              DO_UWOLNIENIA: 'To be released',
              UWOLNIONE: 'Released',
              DO_ZNISZCZENIA: 'To be destroyed',
              ZNISZCZONE: 'Destroyed',
            },
            orderDetails: 'Order details',
            orderNumber: 'Production order number',
            materialNumber: 'Material number',
            brand: 'Brand',
            lockStatus: 'Current action',
            release: 'Released',
            locked: 'To be locked',
            endOfOrder: 'Until the end of the order',
            tooltipFilter:
              'Available fields for filtering: report number, incompatibility type, incompatibility reason, order number, batch, index, material name.',
            blockQtyDescription: 'Enter the quantity to be blocked',
            initialQty: 'Initial lock quantity',
            actualQty: 'Actual lock quantity',
            releaseQty: 'Released quantity',
            destroyQty: 'Destroyed quantity',
          },
          common: {
            serverError: 'Server error',
            isNan: 'Value must be a number',
            qtyEmpty: 'Quantity cannot be empty',
            qtyNegative: 'Quantity cannot be negative',
            qtyExceeds:
              'The entered quantity exceeds the currently locked quantity',
          },
          rnModule: {
            runRn: 'Run RN module',
            laboratory: 'Laboratory',
            packagingLine: 'Packaging Line',
            laboratoryResults: 'Laboratory - Results',
            decisionMaker: 'Decision Maker',
            laboratorySummary: 'Laboratory - Summary',
            repair: 'Repair',
            stage_1: {
              identificationFinishGoods: 'Packed product id',
              rnNumber: 'RN number',
              productionDate: 'Packaging date',
              analyzeDate: 'Date of analysis',
              orderNumber: 'Order number',
              brand: 'Brand',
              materialNumber: 'Material number',
              packagingCode: 'Id on package',
              package: 'Unit',
              expirityDate: 'Best before date',
              BBTnumber: 'BBT number',
              other: 'Other',
              details: 'Volume blocked HL / hours',
              resultsOfAnalysis: 'Packed product micro analysis',
              cultureYeast: 'WLN (culture yeast)',
              wildYeast: 'WLN (wild yeast)',
              aerobicBacteria: 'WLN (aerobic bacteria)',
              beerSpoilageBacteria: 'NBB* / m-NBBA (beer spoilage bacteria)',
              nbbTooltip: '*NBB: NBB-A, NBB-B, NBB-C, NBB-PCR',
              other_micro_1: 'Other',
              pcrIdentifiaction: 'PCR identification',
              pcrTooltip: '** if necessary',
              submitMicro_1: 'Add analysis result',
              micro_1user: 'Signature of report initiator',
              samplerIdentification: 'Sampler id "Post pasteurisation"',
              qtyHL: 'Quantity HL',
              submitSampler: 'Add sampler result',
              resultsOfAnalysisSampler:
                'Sampler micro result "Post pasteurisation"',
              confirmationFirstStep: 'Confirm data',
            },
            stage_2: {
              date: 'Date',
              signature: 'Signature',
              stage_results: 'Filled by area accountable',
              reason: 'Nonconformity root cause',
              description: 'Comments on instant action taken',
              actions_taken: 'Long term action to eliminate root cause taken',
              actons_yes: 'Yes',
              actions_no: 'No',
              if_yes: 'If yes, notes are acessible in: ',
              form: 'form',
              problemDatabase: 'problem database',
              other: 'Other',
              problemDatabaseNumber: 'Problem database number',
              additionalDescription: 'Additional data',
              qtyHLBlocked: 'Quantity HL (blocked)',
              orderNumber: 'Order number and hour',
            },
            stage_3: {
              resultsOfAnalysis: 'Micro results of reference samples',
              hour: 'Hour',
              ezFluo: 'Ez-Fluo',
              identificationFinishGoods: 'Sample identification',
            },
            stage_4: {
              description: 'Filled in by Decision Maker*',
              tooltipDescription: '* Acc to PZ/04 - Brewery Director',
              proceeding: 'Proceeding with nonconfiormancy',
              decision: 'Decision',
              decisionRelease: 'Release in current state in volume',
              decisionBack: 'Recall from the market in volume',
              decisionDestroy: 'Discard in its current state in volume',
              decisionComments: 'Other / comments',
              qtyHL: 'Quantity HL',
              dateOfDecision: 'Date of decision',
              decisionMakerSignature: 'Signature of decision maker*',
            },
            stage_5: {
              additionalDescription: 'Additional comments',
            },
            fiz_1: {
              materialNumber: 'Material number',
              orderNumber: 'Order number',
              material: 'Material',
              line: 'Department / line number',
              bbt: 'BBT',
              batch: 'Batch',
              brand: 'Brand',
              identificationDescription:
                'Nonconformity and full identification of nonconforming batch',
              bbtTooltip:
                'optional field (can be filled for finished product nonconformity)',
              inconformity: 'Nonconformity',
              specification: 'Specification',
              bbtRelease: 'BBT release range',
              analyzeResults: 'Analysis results',
              releaseRange: 'Release range',
              releaseZone: 'Release zone',
              bbtResults: 'BBT analysis result*',
              packagingType: 'Packaging type',
              comment: 'Comment',
              beerBlocked: 'Blocked beer',
              packagingCode: 'Packaging code + BBT',
              button: {
                addAnalyzeResults: 'Add analysis results',
                confirmData: 'Confirm and submit',
              },
              table: {
                parameter: 'Parameter',
                specification: 'Specification',
                analyzeResults: 'Analysis results',
                releaseRange: 'Release range',
                releaseZone: 'Release zone',
                bbtRelease: 'BBT range',
                bbtResults: 'BBT result',
                packagingCode: 'Packaging code',
                comment: 'Comment',
                user: 'User',
              },
              snackbar: {
                successAddParameter: 'Parameter added successfully',
                errorAddParameter: 'Error adding parameter',
                successRemoveParameter: 'Parameter removed successfully',
                errorRemoveParameter: 'Error removing parameter',
              },
              roleTooltip: 'Role responsible for filling in the form',
            },
            fiz_2: {
              date: 'Date',
              signature: 'Signature',
              stage_results: 'Filled by area accountable',
              reason: 'Nonconformity root cause',
              description: 'Comments on instant action taken',
              actions_taken: 'Long term action to eliminate root cause taken',
              actons_yes: 'Yes',
              actions_no: 'No',
              if_yes: 'If yes, notes are acessible in: ',
              form: 'form',
              problemDatabase: 'problem database',
              other: 'Other',
              problemDatabaseNumber: 'Problem database number',
              additionalDescription: 'Additional data',
              qtyHLBlocked: 'Quantity HL (blocked)',
              qtyCasBlocked: 'Quantity cas (blocked)',
              orderNumber: 'Order number and hour',
              button: {
                saveChanges: 'Save changes',
                confirmData: 'Confirm and submit',
              },
              snackbar: {
                successAddData: 'Data saved successfully',
                errorAddData: 'Error adding data',
                successUpdateData: 'Data updated successfully',
                errorUpdateData: 'Error updating data',
              },
            },
            fiz_3: {
              description: 'Filled in by Decision Maker*',
              tooltipDescription: '* Acc to PZ/04 - Brewery Director',
              proceeding: 'Proceeding with nonconfiormancy',
              decision: 'Decision',
              decisionRelease: 'Release in current state in volume',
              decisionRepair: 'Send for rework in volume',
              decisionDestroy: 'Discard in its current state in volume',
              decisionComments: 'Other / comments',
              qtyCas: 'Quantity cas',
              dateOfDecision: 'Date of decision',
              button: {
                confirmData: 'Confirm and submit',
              },
              snackbar: {
                successAddData: 'Data saved successfully',
                errorAddData: 'Error adding data',
                successUpdateData: 'Data updated successfully',
                errorUpdateData: 'Error updating data',
              },
            },
            fiz_4: {
              description:
                'Refers to release/destruction after repair in one or more stages',
              noRepairOrder: 'No repair order created for this nonconformity',
              noRepairDecision:
                'No repair decision made for this nonconformity',
              repairOrderData: 'Repair order data',
              comment: 'Comment*',
              repairOrderDescription: 'Repair order details - description',
              button: {
                repairOrderRequest: 'Submit repair order request',
              },
              tooltip: {
                comment:
                  'optional field (can be filled for finished product nonconformity)',
              },
              noActionRepairOrder:
                'No repair results entered yet for this nonconformity.',
            },
          },
        },
      },
      pl: {
        translation: {
          login: {
            description: 'Zaloguj',
            longDescription: 'Wprowadź dane logowania',
          },
          account: {
            description: 'Moje konto',
            newUser: 'Dodaj nowego użytkownika',
            firstName: 'Imię',
            lastName: 'Nazwisko',
            warehouse: 'Magazyn',
            password: 'Hasło',
            repeatPassword: 'Powtórz hasło',
            userPermissions: 'Uprawnienia',
            newUserForm: 'Formularz nowego użytkownika',
            users: 'Użytkownicy',
            logout: 'Wyloguj',
            userList: 'Lista użytkowników',
            userName: 'Użytkownik',
            userRole: 'Uprawnienia',
            accountStatus: 'Status konta',
            action: 'Akcja',
            userLine: 'Linia',
          },
          bins: {
            bin: 'Lokalizacja',
            binList: 'Lista binów',
            name: 'Nazwa binu',
            warehouse: 'Magazyn',
            create: 'Formularz tworzenia',
            editForm: 'Formularz edycji binu',
          },
          button: {
            confirmButton: 'Zatwierdź',
            addNewUser: 'Dodaj nowego użytkownika',
            edit: 'Edytuj',
            addBeer: 'Dodaj nowy materiał',
            add: 'Dodaj',
            generateReport: 'Generuj raport',
            addAttachment: 'Dodaj załącznik',
            startAction: 'Rozpocznij działanie',
            close: 'Zamknij',
          },
          masterData: {
            descriptionBeer: 'Piwo',
            brand: 'Marka',
            packages: 'Opakowania',
            beerList: 'Lista piw',
            desIncompatibilities: 'Niezgodności',
            origins: 'Pochodzenie',
            area: 'Obszar',
            type: 'Rodzaj',
            description: 'Opis',
            additionalDes: 'Dodatkowy opis',
            reasons: 'Przyczyny niezgodności',
            warehouse: 'Magazyn',
            line: 'Linia produkcyjna',
            button: {
              saveChanges: 'Zapisz zmiany',
              save: 'Zapisz',
              cancel: 'Anuluj',
              add: 'Dodaj',
            },
            specification: {
              title: 'Specyfikacja',
              specificationList: 'Lista specyfikacji',
              parameter: 'Parametr',
              unit: 'Jednostka',
              minValueX: 'Min strefy X',
              maxValueX: 'Max strefy X',
              minValueB: 'Min strefy B',
              maxValueB: 'Max strefy B',
              minDefaultValue: 'Minimum',
              maxDefaultValue: 'Maksimum',
              nominalDefaultValue: 'Nominalna',
              defaultValue: 'Specyfikacja',
              addButton: 'Dodaj specyfikację',
              description: 'Parametr',
              whLine: 'Magazyn/Linia',
              minX: 'Strefa X',
              minB: 'Strefa B',
              maxB: 'Strefa B',
              maxX: 'Strefa X',
              isLineSpecific: 'Specyfikacja dla linii',
              decisionMaker: 'Decydent',
              addNewSpecification: 'Dodaj nową specyfikację',
            },
            mailing: 'Mailing',
            recipients: 'Odbiorcy',
            recipientsList: 'Lista odbiorców',
            email: 'Email',
            isActive: 'Aktywny',
            mailingList: 'Lista mailingowa',
            mailingGroup: 'Grupa mailingowa',
            mailingDetail: 'Szczegóły grupy mailingowej',
            setMembers: 'Ustaw członków grupy',
          },
          pz05: {
            description: 'Rejestr PZ05',
            listIncompatibilities: 'Lista niezgodności',
            addIncompatibility: 'Dodaj niezgodność',
            reportPZ05: 'Raport PZ05',
            incompatibilities: {
              origins: {
                addForm: 'Formularz tworzenia pochodzenia produktu',
                description: 'Pochodzenie produktu',
                editForm: 'Formularz edycji pochodzenia produktu',
              },
              area: {
                addForm: 'Formularz tworzenia obszaru niezgodności',
                description: 'Obszar niezgodności',
                editForm: 'Formularz edycji obszaru niezgodności',
              },
              type: {
                addForm: 'Formularz tworzenia rodzaju niezgodności',
                description: 'Rodzaj niezgodności',
                editForm: 'Formularz edycji rodzaju niezgodności',
              },
              description: {
                addForm: 'Formularz tworzenia opisu niezgodności',
                description: 'Opis niezgodności',
                editForm: 'Formularz edycji opisu niezgodności',
              },
              addDes: {
                addForm: 'Formularz tworzenia dodatkowego opisu niezgodności',
                description: 'Dodatkowy opis niezgodności',
                editForm: 'Formularz edycji dodatkowego opisu niezgodności',
              },
              reasons: {
                reasonsList: 'Lista przyczyn niezgodności',
                addForm: 'Formularz tworzenia przyczyny niezgodności',
                description: 'Przyczyna niezgodności',
                editForm: 'Formularz edycji przyczyny niezgodności',
                button: 'Dodaj nową przyczynę',
                area: 'Obszar',
                type: 'Rodzaj',
                des: 'Opis',
                addDes: 'Dodatkowy opis',
                decisionMaker: 'Decydent',
              },
            },
            report: {
              dateFrom: 'Data początkowa',
              dateTo: 'Data końcowa',
              warehouse: 'Magazyn',
            },
            addForm: 'Formularz dodawania nowej niezgodności',
            editForm: 'Formularz edycji niezgodności',
            productDetails: 'Szczegóły produktu',
            comments: 'Uwagi',
            attachments: 'Załączniki',
            register: 'Lista niezgodności PZ05',
            tooltipFilter:
              'Dostępne pola do filtrowania: numer raportu, indeks, nazwa materiału oraz wymagane działanie',
            statusNew: 'Nowy',
            statusInProgress: 'W trakcie',
            statusCompleted: 'Zakończony',
            filter: 'Filtruj',
            list: {
              reportNumber: 'Numer raportu',
              warehouse: 'Magazyn źródłowy',
              user: 'Użytkownik',
              dateCreated: 'Data utworzenia',
              index: 'Indeks',
              materialName: 'Nazwa materiału',
              type: 'Rodzaj niezgodności',
              actionRequired: 'Wymagane działanie',
              status: 'Status',
            },
            incompatibilityReport: 'Raport niezgodności',
            redCard: 'Czerwona kartka',
            basicInfo: 'Dane podstawowe',
            dateCreated: 'Data wystawienia raportu',
            reportDetails: 'Szczegóły niezgodności',
            productOrigin: 'Pochodzenie produktu',
            productInfo: 'Dane produktu',
            actions: 'Działania',
            decision: 'Decyzja',
            decisionComments: 'Komentarz',
            qualification: 'Kwalifikacja',
            actionDetail: {
              name: 'Nazwa',
              qty: 'Ilość',
              qtyHL: 'Ilość HL',
              expect: 'Oczekuje działania',
              role: 'Rola',
              date: 'Data',
              split: 'Podziel pozycję',
              changeQty: 'Zmień ilość',
              action: 'Działanie',
              newQty: 'Nowa ilość',
              description: 'Podaj wartość do podziału',
              val1: 'Wartość 1',
              val2: 'Wartość 2',
            },
          },
          brand: {
            description: 'Marka',
            create: 'Formularz tworzenia',
            descriptionField: 'Opis',
            edit: 'Formularz edycji marki',
          },
          package: {
            description: 'Opakowanie',
            create: 'Formularz tworzenia',
            descriptionField: 'Opis',
            edit: 'Formularz edycji opakowania',
          },
          beer: {
            beerList: 'Lista wyrobu gotowego',
            index: 'Indeks',
            name: 'Nazwa materiału',
            durability: 'Trwałość',
            quantity: 'Ilość/PAL',
            hl: 'HL/cas',
            package: 'Opakowanie',
            brand: 'Marka',
            editForm: 'Formularz edycji wyrobu gotowego',
            addForm: 'Formularz tworzenia nowego wyrobu gotowego',
            batch: 'Partia',
            expirationDate: 'Data przydatności',
            qty: 'Ilość [cas]',
            qtyPAL: 'Ilość [PAL]',
            qtyHL: 'Ilość [HL]',
            notFull: 'Końcówka z produkcji',
            fullPallets: 'Pełne palety',
          },

          pz04: {
            description: 'Rejestr PZ04',
            listIncompatibilities: 'Lista niezgodności',
            addIncompatibility: 'Dodaj niezgodność',
            reportPZ04: 'Raport PZ04',
            register: 'Lista niezgodności PZ04',
            addForm: 'Formularz dodawania nowej niezgodności',
            type: 'Rodzaj niezgodności',
            reason: 'Przyczyna niezgodności',
            data: 'Dane niezgodności',
            dataProduct: 'Dane produktu',
            details: 'Dodatkowe informacje',
            beerLocked: 'Wyrób zablokowany',
            beerUnlocked: 'Wyrób odblokowany',
            typeLock: 'Rodzaj blokady',
            hourBlockFrom: 'Data przydatności od godziny',
            hourBlockTo: 'Data przydatności do godziny',
            binList: 'Lista binów',
            yellowCard: 'Żółta kartka',
            redCard: 'Czerwona kartka',
            yes: 'Tak',
            no: 'Nie',
            title: 'Niezgodność',
            commentsPlaceholder: 'Wprowadź komentarz',
            PODEJRZENIE_NIEZGODNOSCI: 'Podejrzenie niezgodności',
            RAPORT_NIEZGODNOSCI: 'Raport niezgodności',
            KWARANTANNA: 'Kwarantanna',
            ssccPlaceholder:
              'Wpisz SSCC, oddzielając je przecinkami lub enterem',
            microDateFrom: 'Data produkcji od godziny',
            microDateTo: 'Data produkcji do godziny',
            qtyToBlock: 'Ilość do zablokowania',
            dataMicroCulture:
              'Dane posiewu (uzupełnia laboratorium mikrobiologii)',
            editForm: 'Formularz edycji niezgodności',
            releaseDate: 'Potencjalna data uwolnienia',
            list: {
              reportNumber: 'Numer niezgodności',
              type: 'Typ',
              reason: 'Przyczyna',
              orderNumber: 'Zlecenie',
              index: 'Indeks',
              materialName: 'Nazwa materiału',
              batch: 'Partia',
              BBT: 'BBT',
              dateCreated: 'Data utworzenia',
              dateMicroCulture: 'Posiew',
              status: 'Status',
            },
            reasons: {
              MIKROBIOLOGIA: 'Mikrobiologia',
              FIZ_CHEM: 'Fizykochemia',
            },
            typesLock: {
              CALE_ZLECENIE: 'Całe zlecenie',
              BLOKADA_GODZIN: 'Blokada godzinowa',
              BLOKADA_BINOW: 'Blokada binów',
              BLOKADA_SSCC: 'Blokada SSCC',
            },
            statuses: {
              NEW: 'Nowy',
              IN_PROGRESS: 'W trakcie',
              DONE: 'Zakończony',
              DO_ZABLOKOWANIA: 'Do zablokowania',
              ZABLOKOWANE: 'Zablokowane',
              DO_UWOLNIENIA: 'Do uwolnienia',
              UWOLNIONE: 'Uwolnione',
              DO_ZNISZCZENIA: 'Do zniszczenia',
              ZNISZCZONE: 'Zniszczone',
            },
            orderDetails: 'Szczegóły zlecenia',
            orderNumber: 'Numer zlecenia produkcyjnego',
            materialNumber: 'Numer materiału',
            brand: 'Gatunek',
            lockStatus: 'Aktualne działanie',
            release: 'Uwolnione',
            locked: 'Do zablokowania',
            endOfOrder: 'Do końca zlecenia',
            tooltipFilter:
              'Dostępne pola do filtrowania: numer raportu, typ niezgodności, przyczyna niezgodności, numer zlecenia, partia, indeks, nazwa materiału.',
            blockQtyDescription: 'Wprowadź ilość do zablokowania',
            initialQty: 'Pierwotna ilość blokady',
            actualQty: 'Aktualna ilość blokady',
            releaseQty: 'Ilość uwolniona',
            destroyQty: 'Ilość zniszczona',
          },
          common: {
            serverError: 'Błąd serwera',
            isNan: 'Wartość musi być liczbą',
            qtyEmpty: 'Ilość nie może być pusta',
            qtyNegative: 'Ilość nie może być ujemna',
            qtyExceeds:
              'Wprowadzona ilość przekracza aktualnie zablokowaną ilość',
          },
          rnModule: {
            runRn: 'Uruchom moduł RN',
            laboratory: 'Laboratorium',
            packagingLine: 'Rozlew',
            laboratoryResults: 'Laboratorium - Wyniki',
            decisionMaker: 'Decydent',
            laboratorySummary: 'Laboratorium - Podsumowanie',
            repair: 'Naprawa',
            stage_1: {
              identificationFinishGoods: 'Identyfikacja wyrobu gotowego',
              rnNumber: 'Numer raportu',
              productionDate: 'Data rozlewu',
              analyzeDate: 'Data analizy',
              orderNumber: 'Numer zlecenia',
              brand: 'Gatunek',
              materialNumber: 'Numer materiału',
              packagingCode: 'Kod na opakowaniu',
              package: 'Opakowanie',
              expirityDate: 'Data przydatności',
              BBTnumber: 'Numer BBT',
              other: 'Inne',
              details: 'Ilość HL zablokowane / godziny',
              resultsOfAnalysis:
                'Wyniki analizy mikrobiologicznej wyrobu gotowego',
              cultureYeast: 'WLN (drożdże szlachetne)',
              wildYeast: 'WLN (drożdże obce)',
              aerobicBacteria: 'WLN (bakterie tlenowe)',
              beerSpoilageBacteria: 'NBB* / m-NBBA (bakterie szkodliwe)',
              nbbTooltip: '*NBB: NBB-A, NBB-B, NBB-C, NBB-PCR',
              other_micro_1: 'Inne',
              pcrIdentifiaction: 'Identyfikacja PCR**',
              pcrTooltip: '** jeśli potrzeba',
              submitMicro_1: 'Dodaj wynik analizy',
              micro_1user: 'Podpis osoby wystawiającej RN',
              samplerIdentification: 'Identyfikacja samplera "Po pasteryzacji"',
              qtyHL: 'Ilość HL',
              submitSampler: 'Dodaj wynik samplera',
              resultsOfAnalysisSampler:
                'Wyniki analizy mikrobiologicznej samplera "Po pasteryzacji"',
              confirmationFirstStep: 'Zatwierdź dane',
            },
            stage_2: {
              stage_results: 'Wypełnia osoba odpowiedzialna za obszar',
              date: 'Data',
              signature: 'Podpis',
              reason: 'Przyczyna niezgodności',
              description:
                'Opis podjętych działań natychmiastowych (korekcyjnych / korygujących)',
              actions_taken:
                'Czy działania korygujące zostały podjęte (eliminacja przyczyny niezgodności)?',
              actons_yes: 'Tak',
              actions_no: 'Nie',
              if_yes: 'Jeśli tak, zapis w: ',
              form: 'formularzu "Działania korygujące/zapobiegawcze"',
              problemDatabase: 'bazie problemów',
              other: 'Inne',
              problemDatabaseNumber: 'Numer bazy problemów',
              additionalDescription: 'Dane dodatkowe',
              qtyHLBlocked: 'Ilość HL (zablokowana)',
              orderNumber: 'Numer zlecenia i godziny',
            },
            stage_3: {
              resultsOfAnalysis:
                'Wyniki analizy mikrobiologicznej prób referencyjnych',
              hour: 'Godzina',
              ezFluo: 'Ez-Fluo',
              identificationFinishGoods: 'Identyfikacja próby',
            },
            stage_4: {
              description: 'Wypełnia Decydent*',
              tooltipDescription: '* wg PZ/04 - Dyrektor Browaru',
              proceeding: 'Postępowanie z wyrobem niezgodnym',
              decision: 'Decyzja',
              decisionRelease: 'Uwolnić w aktualnym stanie w ilości',
              decisionBack: 'Wycofać z łańcucha dostaw (CD/MC/rynek) w ilości',
              decisionDestroy: 'Zniszczyć w aktualnym stanie w ilości',
              decisionComments: 'Inne / uwagi',
              qtyHL: 'Ilość HL',
              decisionMakerSignature: 'Podpis decydenta*',
              dateOfDecision: 'Data decyzji',
            },
            stage_5: {
              additionalDescription: 'Dane uzupełniające',
            },
            fiz_1: {
              materialNumber: 'Numer materiału',
              orderNumber: 'Numer zlecenia',
              material: 'Materiał',
              line: 'Dział / nr linii',
              bbt: 'BBT',
              batch: 'Partia',
              brand: 'Gatunek',
              identificationDescription:
                'Niezgodność i pełna identyfikacja niezgodnej partii',
              bbtTooltip:
                'pole nieobowiązkowe (można uzupełnić dla niezgodności wyrobu gotowego)',
              inconformity: 'Niezgodność',
              specification: 'Specyfikacja',
              bbtRelease: 'Zakres uwolnienia BBT',
              analyzeResults: 'Wyniki analizy',
              releaseRange: 'Zakres uwolnienia',
              releaseZone: 'Strefa uwolnienia',
              bbtResults: 'Wynik analizy BBT*',
              packagingType: 'Typ opakowania',
              comment: 'Komentarz',
              beerBlocked: 'Czy wymagana blokada piwa?',
              packagingCode: 'Kod na opakowaniu + nr BBT',
              button: {
                addAnalyzeResults: 'Dodaj parametr',
                confirmData: 'Zatwierdź i wyślij',
              },
              table: {
                parameter: 'Parametr',
                specification: 'Specyfikacja',
                analyzeResults: 'Wyniki analizy',
                releaseRange: 'Zakres uwolnienia',
                releaseZone: 'Strefa uwolnienia',
                bbtRelease: 'Zakres BBT',
                bbtResults: 'Wynik analizy BBT',
                packagingCode: 'Kod na opakowaniu',
                comment: 'Komentarz',
                user: 'Użytkownik',
              },
              snackbar: {
                successAddParameter: 'Pomyślnie dodano parametr',
                errorAddParameter: 'Błąd podczas dodawania parametru',
                successRemoveParameter: 'Pomyślnie usunięto parametr',
                errorRemoveParameter: 'Błąd podczas usuwania parametru',
              },
              roleTooltip: 'Brak wymaganych uprawnień do zatwierdzania danych',
            },
            fiz_2: {
              stage_results: 'Wypełnia osoba odpowiedzialna za obszar',
              date: 'Data',
              signature: 'Podpis',
              reason: 'Przyczyna niezgodności',
              description:
                'Opis podjętych działań natychmiastowych (korekcyjnych / korygujących)',
              actions_taken:
                'Czy działania korygujące zostały podjęte (eliminacja przyczyny niezgodności)?',
              actons_yes: 'Tak',
              actions_no: 'Nie',
              if_yes: 'Jeśli tak, zapis w: ',
              form: 'formularzu "Działania korygujące/zapobiegawcze"',
              problemDatabase: 'bazie problemów',
              other: 'Inne',
              problemDatabaseNumber: 'Numer bazy problemów',
              additionalDescription: 'Dane dodatkowe',
              qtyHLBlocked: 'Ilość HL (niezgodna)',
              qtyCasBlocked: 'Ilość [cas] (niezgodna)',
              orderNumber: 'Numer zlecenia i godziny',
              button: {
                saveChanges: 'Zapisz zmiany',
                confirmData: 'Zatwierdź i wyslij',
              },
              snackbar: {
                successAddData: 'Dane zapisane pomyślnie',
                errorAddData: 'Błąd podczas dodawania danych',
                successUpdateData: 'Dane zaktualizowane pomyślnie',
                errorUpdateData: 'Błąd podczas aktualizacji danych',
              },
            },
            fiz_3: {
              description: 'Wypełnia Decydent*',
              tooltipDescription:
                '* strefa B (niezgodne parametry QC/QA wyrobu gotowego) -dyrektor browaru; strefa X (niezgodne parametry QC/QA wyrobu gotowego) - dyrektor browaru / HUB; PPQA - dyrektor browaru; CCP - dyrektor browaru; O-CP - wg procedur/instrukcji O-CP dla browarów',
              proceeding: 'Postępowanie z wyrobem niezgodnym',
              decision: 'Decyzja',
              decisionRelease: 'Uwolnić w aktualnym stanie w ilości',
              decisionRepair: 'Skierować do naprawy w ilości',
              decisionDestroy: 'Zniszczyć w aktualnym stanie w ilości',
              decisionComments: 'Inne / uwagi',
              qtyCAS: 'Ilość CAS',
              decisionMakerSignature: 'Podpis decydenta*',
              comment: 'Komentarz',
              dateOfDecision: 'Data decyzji',
              button: {
                confirmData: 'Zatwierdź i wyślij',
              },
              snackbar: {
                successAddData: 'Dane zapisane pomyślnie',
                errorAddData: 'Błąd podczas dodawania danych',
                successUpdateData: 'Dane zaktualizowane pomyślnie',
                errorUpdateData: 'Błąd podczas aktualizacji danych',
              },
            },
            fiz_4: {
              description:
                'Dotyczy uwolnienia / zniszczenia po naprawie w jednym lub kilku etapach',
              noRepairOrder: 'Brak zlecenia naprawy dla tej niezgodności',
              noRepairDecision:
                'Brak decyzji dotyczącej naprawy dla tej niezgodności',

              repairOrderData: 'Dane zlecenia naprawy',
              comment: 'Komentarz*',
              repairOrderDescription: 'Szczegóły naprawy - opis',
              button: {
                repairOrderRequest: 'Złóż wniosek o zlecenie naprawy',
              },
              tooltip: {
                comment:
                  'pole nieobowiązkowe (można uzupełnić dla niezgodności wyrobu gotowego)',
              },
              noActionRepairOrder:
                'Nie wprowadzono jeszcze wyników naprawy dla tej niezgodności.',
            },
          },
        },
      },
    },
  });

export default i18n;
